import { DestroyRef, Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { UniqueSalesforceTargetFieldForm } from './form.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class DivisionSalesforceTargetsFormValidatorsService {
    public salesforceTargetTakenValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const controlValue: string = control.getRawValue() as UniqueSalesforceTargetFieldForm['name']['value'];
            if (!controlValue) {
                return null;
            }

            const parentFormArray = control?.parent?.parent as FormArray<FormGroup<UniqueSalesforceTargetFieldForm>>;
            if (!parentFormArray) {
                return null;
            }

            const valueAlreadyClaimed =
                parentFormArray.controls.filter(uniqueSFTargetFormGroup => {
                    // IMPORTANT
                    // If I just used the value directly, it was always one keystroke beyind.
                    // `control.parent.parent`'s `value` object reference is not updated until
                    // this validator of its child is done. So its `value` stale, as the parent form's
                    // value is not yet recalculated.
                    //
                    // However, reading from the control itself
                    // seems to have the currect value of the parent???
                    // AI told me this and I was able to verify it...
                    //
                    // I (Michael) am trusting this because the following verifies that
                    //     // One field is 'test' and the other is 'tes'. Then I type a 't' into the second.
                    //     console.debug(parentFormArray.getRawValue(), parentFormArray.controls);
                    //     // Readout:
                    //     //    [{...},{..., name: 'tes'}],
                    //     //    [{...},{(control's `name` control `value`): 'test'}]
                    const nameCtrl: FormControl<string> = uniqueSFTargetFormGroup.controls.name;

                    return nameCtrl.getRawValue() === controlValue;
                }).length > 1;

            return valueAlreadyClaimed ? { nameTaken: true } : null;
        };
    }

    /**
     * @description If Field 2 is set to the same value as Field 1, but Field 1 changes value,
     * then Field 2's validation does not automatically update. This will re-run the
     * `salesforceTargetTakenValidator` validator.
     */
    public updateSalesForceTargetNameValidatorsOnOtherNamesChanging(
        uniqueSFTargetFieldsArr: FormArray<FormGroup<UniqueSalesforceTargetFieldForm>>,
        destroyRef: DestroyRef
    ) {
        uniqueSFTargetFieldsArr.valueChanges.pipe(takeUntilDestroyed(destroyRef)).subscribe(val => {
            for (let i = 0; i < val.length; i++) {
                uniqueSFTargetFieldsArr.controls.at(i)?.controls.name.updateValueAndValidity({ emitEvent: false });
            }
        });
    }
}
